// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"TransactionScreen_titleWrapper__2a7bP","primaryFieldsWrapper":"TransactionScreen_primaryFieldsWrapper__ghy_e"};